var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('VueTelInput',{attrs:{"default-country":_vm.defaultCountry,"dropdown-options":{
      'showDialCodeInList':true,
      'showDialCodeInSelection':false,
      'showFlags':true,
      'showSearchBox':true,
    },"input-options":{
      'autofocus':true,
      'showDialCode':true,
      'placeholder':'+54 9 11 3288 4589',
      'required':true,
    },"mode":'international',"valid-characters-only":true},on:{"validate":_vm.validatePhoneNumber},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}}),_c('i',{class:_vm.userPhoneIcon,attrs:{"aria-hidden":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }